import { AccuserModel, UserAccuseritemModel, UserAccuserModel } from "./conferencing";

export class AboutCourtFeesModel {
    status2: any
    administrativeCourt: number = null!;
    blackNumberCase: number = null!;
    radNumberCase: number = null!;
    suitBlackCode: number = 0;
    suitBlackYear: number = 0;
    suitRadCode: number = 0;
    suitRadYear: number = 0;
    status: number = 0
    subStatus: any
    accusers: AccuserModel = new AccuserModel
    // plaintiffAndAttorneyNumbers: AccuseritemModel[] = []
    // defendantAndAttorneyNumbers: AccuseritemModel[] = []
    suitID: number = 0;
    fdTID: number = 42;
    reQID: number = 0;

    remark: string = ''

}
export class inputSearchModel {
    administrativeCourt: number = null!;
    blackNumberCase: number = null!;
    suitBlackCode: number = null!;
    suitBlackYear: string = null!;
    redNumberCase: number = null!;
    suitRedCode: number = null!;
    suitRedYear: string = null!;
    suitTypeId: number = 0
    fdtId: number = null!
}

export class inputPaymentModel {
    checkBill: number = 2
    choosePayment: number = 0
    paymentOption: number = 0

    statusCourtFees: number = null!
    refCode: string = null!
    filingDate: Date = new Date
    prefixName: string = ''
    firstName: string = ''
    lastName: string = ''
    day: string = ''
    mouth: string = ''
    year: number = null!
    userAccuser: PayUserAccuserModel = new PayUserAccuserModel
    plaintiffs: UserAccuserPaymentitemModel[] = []
    prosecutors: UserAccuserPaymentitemModel[] = []
    sumCapital: number = 0;
    sumFee: number = 0;
    seq: number = 1;
    selected = false;
    submitted = false;
    inAppealCase = false
    payCase: number = null!
    combinePayDate: Date = new Date
    combinePayCompleteDate: Date = new Date
    combinePayStatus: number = null!
    confirm = false
    paymentRefCode1: number = null!;
    paymentRefCode2: number = null!;
    courtBankAccount: string = null!
    courtBankAccountNo: number = null!
    bankAgency: string = null!
    additionalPay: AdditionalPaymentDetailModel[] = []
}

export class PayUserAccuserModel {
    suiT_ACC_DATE!: Date
    suiT_BLACK_NO!: number
    suiT_RED_NO!: number
    suiT_BLACK_YEAR!: string
    suiT_RED_YEAR!: string
    courtName!: string
    secCode!: string
    items: UserAccuserPaymentitemModel[] = []
}

export class UserAccuserPaymentitemModel {

    groupId: number = 0
    groupName: string = ''
    accName: string = ''
    accId: number = 0
    capital: number = 0;
    fee: number = null!;
    preCapital: number = 0
    preFees: number = 0
    payCompleteDate: Date = new Date
    payDate: Date = new Date
    payStatus: number = null!
    seq: number = 0
}

export class UserDetailAboutCourtFeesModel {
    administrativeCourt: number = null!;
    blackNumberCase: number = null!;
    suitBlackCode: number = 0;
    suitBlackYear: number = 0;
    day: number = null!
    mont: number = null!
    monthName: string = ''
    year: number = null!
    time: any
    prefixName: string = ''
    firstName: string = ''
    lastName: string = ''
    filingAS: number = 0

}

export class PaymentCourtFeesModel {
    caseId: number = 0
    accId: number = 0
    billId: number = 0
    refCode: string = null!
    payUserName: string = ''
    courtName: string = ''
    paymentRefCode1: string = null!
    paymentRefCode2: string = null!
    courtBankAccount: string = null!
    courtBankAccountNo: number = null!
    bankAgency: string = null!
    fees: number = null!
    payInNo: number = null!
    payDate: Date = null!
    payCompleteDate: Date = new Date
    payComplete: boolean = null!
    email: string = ''
    genQrCode: string = ''
    amount: number = 0
    payCode: string = ''
    title: string = ''
    name1: string = ''
    name2: string = ''
}

export class SummaryPaymentDetailModel {
    checkBill: number = 2
    choosePayment: number = 0
    paymentOption: number = 0
    statusCourtFees: number = null!
    refCode: string = null!
    filingDate: Date = new Date
    prefixName: string = ''
    firstName: string = ''
    lastName: string = ''
    sumCapital: number = 0
    sumFee: number = 0
    combinePayDate: Date = new Date
    combinePayCompleteDate: Date = new Date
    combinePayStatus: number = null!
    userAccuser: PayUserAccuserModel = new PayUserAccuserModel
    plaintiffs: UserAccuserPaymentitemModel[] = []
    prosecutors: UserAccuserPaymentitemModel[] = []
    additionalPay: AdditionalPaymentDetailModel[] = []

}

export class AdditionalPaymentDetailModel {
    checkBill: number = 2
    choosePayment: number = 0
    paymentOption: number = 0
    payDate: Date = new Date
    sumCapital: number = 0
    sumFee: number = 0
    plaintiffs: UserAccuserPaymentitemModel[] = []

}

export class GetBillModel {
    paidStatus: number = null!
    caseId: number = 0
    billId: number = 0
    accId: number = 0
    suitFeeType: number = 0
    refCode: string = null!
    courtName: string = null!
    suitTypeAbbr: string = null!
    suitBlackNo: number = 0
    suitBlackYear: string = null!
    suitRedNo: number = 0
    suitRedYear: string = null!
    payCode1: string = null!
    payCode2: string = null!
    payDate: Date = null!
    payMethod: number = 0
    payToTal: number = 0
    payUserName: string = null!
    paySubject: string = null!
    isAppeal:boolean = false
    addFeeId:number = 0
}

export class genBillPdfModel {
    kind: string = ''
    id: number = 0
    originalName: string = ''
    storeName: string = ''
    mimeType: string = ''
    extension: string = ''
    sizeInBytes: number = 0
    url: string = ''
    upLoadDate: Date = null!
    upLoadBy: string = ''
    pageNumber: number = 0
    pageStart: number = 0
    pageEnd: number = 0
    urlByName: string = ''
    isGaruda: boolean = true
}

export class PaymentCheckModel{
    suitId:number = 0
    isExist:boolean = null!
    isCurrent:boolean = null!
}

export class RefCodeChecModel{
    isExitBlackNo:boolean = null!
    isSuitOwner:boolean = null!
    isPayment:boolean = null!
}

export class DataServiceModel{
    cId: number = 0
    secId: number = 0
    suitId: number = 0
    caseId: number = 0
}


